const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

async function parseJson(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

export async function fetchPresupuestos({ signal } = {}) {
  const response = await fetch(`${API_BASE_URL}/presupuestos/anulados`, {
    method: 'GET',
    signal,
  });
  if (!response.ok) {
    throw new Error(`Request failed (${response.status}) ${response.statusText}`);
  }
  const payload = await response.json();
  return payload?.data ?? [];
}

export async function fetchPresupuestosActivos({ signal } = {}) {
  const response = await fetch(`${API_BASE_URL}/presupuestos`, {
    method: 'GET',
    signal,
  });
  if (!response.ok) {
    throw new Error(`Request failed (${response.status}) ${response.statusText}`);
  }
  const payload = await response.json();
  return payload?.data ?? [];
}

export async function createPresupuesto(dePresupuesto) {
  const response = await fetch(`${API_BASE_URL}/presupuestos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ de_presupuesto: dePresupuesto }),
  });
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}

export async function togglePresupuestoStatus(cdPresupuesto) {
  const response = await fetch(
    `${API_BASE_URL}/presupuestos/${cdPresupuesto}/anular`,
    { method: 'PATCH' },
  );
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}

export async function updatePresupuesto(cdPresupuesto, dePresupuesto) {
  const response = await fetch(`${API_BASE_URL}/presupuestos/${cdPresupuesto}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ de_presupuesto: dePresupuesto }),
  });
  const body = await parseJson(response);
  return { ok: response.ok, status: response.status, data: body?.data ?? null };
}